import { ReducerFunctions } from "../../utils";
import { FetchPaymentLinks, SaveBulkUploads, FetchBulkUploads, SaveBulkUploadPaymentLink, DownloadBulkUploads, DeletePaymentLink} from "./transfers";


export const fetch_payment_links_reducer = ReducerFunctions(FetchPaymentLinks, {});
export const delete_payment_link_reducer = ReducerFunctions(DeletePaymentLink, {});
export const save_bulk_uploads = ReducerFunctions(SaveBulkUploads, {});
export const fetch_bulk_uploads_reducer = ReducerFunctions(FetchBulkUploads, {});
export const save_bulk_upload_payment_link_reducer = ReducerFunctions(SaveBulkUploadPaymentLink, {});
export const download_bulk_upload_reducer = ReducerFunctions(DownloadBulkUploads, {});